class BackInStock extends HTMLElement {
  constructor() {
    super();
    this.initialize();
  }

  initialize() {
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(e) {
    e.preventDefault();

    const variantId = this.dataset.variantId;
    const productTitle = this.escapeHTML(this.dataset.productTitle || '');
    const variantTitle = this.escapeHTML(this.dataset.variantTitle || '');

    const modalHtml = `
      <div class="modal modal--end bis-modal" role="dialog" aria-modal="true" aria-label="${productTitle}">
        <div class="modal__overlay"></div>
        <div class="modal__container">
          <div class="modal__content">
            <div class="modal__header">
              <div class="bis-title-container">
                <span class="modal__title heading modal__title__bis">
                  ${productTitle}
                </span>
                <span class="bis-variant-title">
                  ${variantTitle}
                </span>
              </div>
              <button 
                type="button" 
                class="modal__close button button--secondary button--close" 
                aria-label="Close"
              >
                <span class="btn-fill" data-fill></span>
                <span class="btn-text">
                  <svg class="icon icon-close" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                    <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </button>
            </div>
            <div class="modal__body">
              <span class="modal__body__bis">Wow, this has flown off the shelves and we've run out. Pop your email in below and we'll let you know as soon as we welcome it back.</span>
              <form data-back-in-stock-form class="form modal__form__bis">
                <div class="field">
                  <input
                    class="input is-floating"
                    type="email" 
                    name="email" 
                    id="email"
                    autocomplete="email"
                    spellcheck="false"
                    autocapitalize="off"
                    placeholder=" "
                    required
                  >
                  <label class="label is-floating" for="email">Email</label>
                </div>
                <input type="hidden" name="variant_id" value="${variantId}">
                <div class="field">
                  <button 
                    type="submit" 
                    class="button button--primary button--fixed w-full"
                   style="background-color: #636e4d;"
                    is="hover-button"
                  >
                    <span class="btn-fill" data-fill></span>
                    <span class="btn-text">Notify me</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    `;

    const existingModal = document.querySelector('.bis-modal');
    if (existingModal) {
      existingModal.remove();
    }

    document.body.insertAdjacentHTML('beforeend', modalHtml);

    const modalStyles = document.createElement('style');
    modalStyles.textContent = `
      .bis-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 50;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .bis-modal .modal__overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
      }

      .bis-modal .modal__container {
        position: relative;
        background: #fff;
        width: 100%;
        max-width: 500px;
        margin: 20px;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
      }

      .bis-modal .modal__content {
        display: flex;
        flex-direction: column;
      }

      .bis-modal .modal__header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 20px;
        border-bottom: 1px solid #e5e5e5;
      }

      .bis-modal .bis-title-container {
        display: flex;
        flex-direction: column;
      }

      .bis-modal .modal__title {
        margin: 0;
        line-height: 1.2;
      }

      .bis-modal .bis-variant-title {
        font-size: 0.875rem;
        line-height: 1.25rem;
        color: #4B5563;
        margin-top: 0.25rem;
      }

      .bis-modal .modal__body {
        padding: 20px;
      }

      .bis-modal .modal__form__bis {
        display: grid;
        gap: 20px;
        margin-top: 20px;
      }
    `;
    document.head.appendChild(modalStyles);

    requestAnimationFrame(() => {
      const modal = document.querySelector('.bis-modal');
      if (!modal) return;

      const closeBtn = modal.querySelector('.modal__close');
      const overlay = modal.querySelector('.modal__overlay');
      const form = modal.querySelector('[data-back-in-stock-form]');

      if (form) {
        form.addEventListener('submit', this.onFormSubmit.bind(this));
      }

      const closeModal = () => {
        modal.remove();
        modalStyles.remove();
      };

      if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
      }
      
      if (overlay) {
        overlay.addEventListener('click', closeModal);
      }
    });
  }

  escapeHTML(text) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    };
    return String(text).replace(/[&<>"']/g, (m) => map[m]);
  }

  onFormSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const submitButton = form.querySelector('button[type="submit"]');
    const modal = document.querySelector('.bis-modal');
    
    submitButton.innerHTML = `
      <span class="btn-fill" data-fill></span>
      <span class="btn-text">
        <svg class="icon icon-spinner animate-spin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
          <g fill="currentColor">
            <g>
              <path d="M24 47a23 23 0 1 1 23-23 23.025 23.025 0 0 1-23 23zm0-42a19 19 0 1 0 19 19A19.021 19.021 0 0 0 24 5z" opacity=".4"></path>
              <path d="M47 24h-4A19.021 19.021 0 0 0 24 5V1a23.025 23.025 0 0 1 23 23z"></path>
            </g>
          </g>
        </svg>
      </span>
    `;

    this.createNotification(form, modal);
  }

  createNotification(form, modal) {
    const formData = new FormData(form);
    const klaviyoKey = window.theme?.klaviyoKey;
    const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${klaviyoKey}`;

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2024-10-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: formData.get('email')
                }
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${formData.get('variant_id')}`
              }
            }
          }
        }
      })
    };

    fetch(url, options)
      .then(async (response) => {
        const responseData = await response.text();

        if (response.status !== 202) {
          throw new Error(`Failed to subscribe: ${responseData}`);
        }

        const successMessage = modal.querySelector('.modal__body__bis');
        successMessage.textContent = "You're on our list!";
        successMessage.style.color = '#4d7c0f';
        
        // Hide the form
        modal.querySelector('[data-back-in-stock-form]').style.display = 'none';
      })
      .catch((error) => {
        console.error('Detailed error:', error);
        modal.querySelector('.modal__body').innerHTML = `
          <div class="error-message text-center p-6">
            <svg class="w-16 h-16 mx-auto mb-4 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h3 class="heading text-xl mb-2">Oops! Something went wrong</h3>
            <p class="text-base text-gray-600 mb-4">Unable to process your request. Please try again.</p>
            <button type="button" class="button button--primary button--fixed" is="hover-button" data-popup-close>
              <span class="btn-fill" data-fill></span>
              <span class="btn-text">Close</span>
            </button>
          </div>
        `;
        // Wire up the dynamically inserted Close button to use the existing close behavior
        const errorCloseButton = modal.querySelector('[data-popup-close]');
        if (errorCloseButton) {
          errorCloseButton.addEventListener('click', () => {
            const headerClose = modal.querySelector('.modal__close');
            if (headerClose) {
              headerClose.click();
            } else {
              modal.remove();
            }
          });
        }
      });
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock);
}